<template>
  <div>
    <!-- Breadcrumb -->
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div>
          <div class="hidden md:flex text-sm text-gray-500">
            <router-link :to="{ name: 'home' }" class="hover:text-primary">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{ name: 'surveys' }" class="hover:text-primary">Surveys</router-link>
          </div>
          <div class="text-2xl text-primary font-bold mt-2">Survey List</div>
        </div>
      </div>
    </nav>

    <!-- Filters -->
    <div class="pb-4">
      <div class="bg-white border rounded-lg shadow p-4">
        <div class="flex justify-between items-center mb-4">
          <div class="font-semibold text-gray-700 text-lg">{{ title }}</div>
          <!-- Export Button -->
          <button
            @click="exportToCSV"
            class="bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-primary-dark transition"
          >
            Export CSV
          </button>
        </div>

        <div class="flex flex-col md:flex-row md:justify-between gap-4 mb-4">
          <!-- Records per page -->
          <div>
            <label class="block text-gray-600 font-medium mb-1">Records per page</label>
            <select v-model="recordsPerPage" @change="fetchSurveys(1)"
              class="block w-full bg-white border border-gray-300 px-3 py-2 rounded-lg shadow-sm focus:outline-none focus:border-primary">
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>

          <!-- Search -->
          <div class="flex-1">
            <label class="block text-gray-600 font-medium mb-1">Search</label>
            <input v-model="searchString" @input="debouncedSearch"
              class="block w-full border border-gray-300 rounded-lg py-2 px-3 shadow-sm focus:outline-none focus:border-primary"
              type="text" placeholder="🔍 Search by title...">
          </div>
        </div>

        <!-- Table -->
        <div class="overflow-x-auto rounded-lg shadow">
          <table v-if="!loading" class="table-auto w-full border-collapse">
            <thead>
              <tr class="bg-gray-100 text-gray-700 text-sm uppercase tracking-wide">
                <th class="px-4 py-3 text-left">#</th>
                <th class="px-4 py-3 text-left">Title</th>
                <th class="px-4 py-3 text-left">Start Date</th>
                <th class="px-4 py-3 text-left">End Date</th>
                <th class="px-4 py-3 text-center">Status</th>
                <th class="px-4 py-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(survey, index) in surveys" :key="survey.id"
                  class="border-t hover:bg-gray-50 transition-colors">
                <td class="px-4 py-3 font-bold">{{ offset + index + 1 }}</td>
                <td class="px-4 py-3 text-primary font-medium">{{ survey.title }}</td>
                <td class="px-4 py-3 text-gray-700">{{ survey.start_date }}</td>
                <td class="px-4 py-3 text-gray-700">{{ survey.end_date }}</td>
                <td class="px-4 py-3 text-center">
                  <span
                    class="px-2 py-1 rounded text-xs font-medium"
                    :class="surveyStatusBadge(survey)"
                  >
                    {{ surveyStatusLabel(survey) }}
                  </span>
                </td>
                <td class="px-4 py-3 text-center">
                  <button class="text-blue-600 hover:underline mx-1" @click="viewSurvey(survey.id)">View</button>
                  <button class="text-yellow-600 hover:underline mx-1">Edit</button>
                  <button class="text-red-600 hover:underline mx-1" @click="deleteSurvey(survey.id)">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Loading -->
          <div v-else class="py-6 text-center w-full text-gray-600">
            <feather animation="spin" type="loader" size="32" class="mr-2"></feather>
            <p>Loading surveys...</p>
          </div>
        </div>

        <!-- Pagination -->
        <Pagination class="py-4"
          :total-count="surveyCount"
          :current-page="currentPage"
          :tag="'surveys'"
          :offset="offset"
          :records-count="surveys.length"
          :click-handler="fetchSurveys"
          :records-per-page="parseInt(recordsPerPage)" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Pagination from "@/components/Pagination.vue";
//import { debounce } from "lodash";

export default {
  name: "SurveyList",
  components: { Pagination },
  data() {
    return {
      breadcrumb: true,
      title: "Available Surveys",
      surveys: [],
      surveyCount: 0,
      currentPage: 1,
      recordsPerPage: 10,
      offset: 0,
      searchString: "",
      loading: false,
      error: null,
    };
  },
  created() {
   // this.fetchSurveys(1);
   // this.debouncedSearch = debounce(this.searchSurveys, 500);
  },
  methods: {
    async fetchSurveys(page = 1) {
      this.loading = true;
      this.currentPage = page;
      this.offset = (page - 1) * this.recordsPerPage;
      try {
        const response = await axios.get("https://apiresources.brandfi.co.ke/api/v1/survey", {
          params: {
            limit: this.recordsPerPage,
            offset: this.offset,
            search: this.searchString || undefined,
          },
        });
        this.surveys = response.data.data || response.data;
        this.surveyCount = response.data.total || this.surveys.length;
      } catch (err) {
        this.error = "Failed to load surveys.";
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    searchSurveys() {
      this.fetchSurveys(1);
    },
    viewSurvey(id) {
      this.$router.push({ name: "survey", params: { id } });
    },
    async deleteSurvey(id) {
      if (!confirm("Are you sure you want to delete this survey?")) return;
      try {
        await axios.delete(`https://apiresources.brandfi.co.ke/api/v1/survey/${id}`);
        this.fetchSurveys(this.currentPage);
      } catch (err) {
        alert("Failed to delete survey.");
        console.error(err);
      }
    },
    surveyStatusBadge(survey) {
      const now = new Date();
      const start = new Date(survey.start_date);
      const end = new Date(survey.end_date);

      if (now < start) return "bg-gray-100 text-gray-600";
      if (now > end) return "bg-red-100 text-red-600";
      return "bg-green-100 text-green-600";
    },
    surveyStatusLabel(survey) {
      const now = new Date();
      const start = new Date(survey.start_date);
      const end = new Date(survey.end_date);

      if (now < start) return "Upcoming";
      if (now > end) return "Expired";
      return "Active";
    },
    exportToCSV() {
      if (!this.surveys.length) {
        alert("No surveys to export.");
        return;
      }

      const headers = ["ID", "Title", "Start Date", "End Date", "Status"];
      const rows = this.surveys.map(s => [
        s.id,
        `"${s.title}"`,
        s.start_date,
        s.end_date,
        this.surveyStatusLabel(s)
      ]);

      const csvContent =
        "data:text/csv;charset=utf-8," +
        [headers.join(","), ...rows.map(r => r.join(","))].join("\n");

      const link = document.createElement("a");
      link.setAttribute("href", encodeURI(csvContent));
      link.setAttribute("download", "surveys.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
};
</script>
